export class Payment {

    // {name: 'C.O.D.', value: 1},
    // {name: '30 days', value: 2},
    // {name: '14 days', value: 3},
    // {name: '7 days', value: 4}

    static COD = 1;
    static Day30 = 2;
    static Day14 = 3;
    static Day7 = 4;

    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}